"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCodeUtil = withCodeUtil;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _stringConsts = require("../../constants/stringConsts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * コード利用共通部品
 *
 */
function withCodeUtil(WrappedComponent) {
  class CodeUtil extends _react.default.Component {
    constructor() {
      super(...arguments);
      /**
       * 選択部品のインターフェースに合わせたコードのリストを取得する.
       * @param {string} kbn - コード区分
       * @param {Array.<string>} [targetGrp] -　指定されたグループ配列で絞り込んで返却する
       * @param {Array.<string>} [excludeGrp] -　指定されたグループ配列を除去して返却する
       */
      _defineProperty(this, "getCodeItems", (kbn, targetGrp, excludeGrp) => {
        const {
          code,
          intl
        } = this.props;
        if (!code[kbn]) {
          return [];
        }
        return code[kbn].filter(item => {
          if (!targetGrp && !excludeGrp) {
            return true;
          }
          if (targetGrp && excludeGrp) {
            if (targetGrp.includes(item.grp) && !excludeGrp.includes(item.grp)) {
              return true;
            }
          }
          if (!targetGrp && excludeGrp) {
            if (!excludeGrp.includes(item.grp)) {
              return true;
            }
          }
          if (targetGrp && !excludeGrp) {
            if (targetGrp.includes(item.grp)) {
              return true;
            }
          }
          return false;
        }).map(item => {
          return {
            displayName: intl.formatMessage({
              id: item.key
            }),
            value: item.cd
          };
        });
      });
      /**
       * コード区分、コード値に対応する表示値を取得する.
       * @param {string} kbn - コード区分
       * @param {string} cd -コード値
       */
      _defineProperty(this, "getCodeName", (kbn, cd) => {
        const {
          code,
          intl
        } = this.props;
        if (cd) {
          for (let i = 0; i < code[kbn].length; i++) {
            if (cd === code[kbn][i].cd) {
              return intl.formatMessage({
                id: code[kbn][i].key
              });
            }
          }
        }
        return _stringConsts.STRING_CONSTS.EMPTY;
      });
    }
    render() {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
        getCodeItems: this.getCodeItems,
        getCodeName: this.getCodeName
      }, this.props));
    }
  }
  const mapStateToProps = state => {
    return {
      code: state.coreLocale.code
    };
  };
  CodeUtil = (0, _reactRedux.connect)(mapStateToProps)(CodeUtil);
  CodeUtil = (0, _reactIntl.injectIntl)(CodeUtil);
  return CodeUtil;
}